import type { RunStatus } from '../api/types';

/** Статусы незавершённого запуска: ждёт в очереди, захвачен воркером или выполняется */
const ACTIVE_RUN_STATUSES: readonly RunStatus[] = ['QUEUED', 'PENDING', 'RUNNING'];

/** Запуск ещё не завершён: его состояние и результаты продолжают меняться */
export const isRunActive = (status: RunStatus): boolean => ACTIVE_RUN_STATUSES.includes(status);
